import { Destructable } from "./types";

export function isDestructable(object: any): object is Destructable {
	return (
		object !== null &&
		typeof object === "object" &&
		object.onDestroy !== undefined &&
		object.destroy !== undefined &&
		object.destroyed !== undefined
	);
}

export function addDependency(destructor1: Destructable, destructor2: Destructable, func: () => void): void {
	if (destructor2.destroyed === true) {
		func();
	} else {
		const sub1 = destructor2.onDestroy(() => {
			if (destructor1.destroyed === true) return;
			sub2.unsubscribe();
			func();
		});
		const sub2 = destructor1.onDestroy(() => sub1.unsubscribe());
	}
}

export function addThreewayDependency(
	parent: Destructable,
	child1: Destructable,
	child2: Destructable,
	func: () => void
): void {
	if (child1.destroyed || child2.destroyed) {
		func();
	} else {
		const sub_child1 = child1.onDestroy(() => {
			sub_parent.unsubscribe();
			sub_child2.unsubscribe();
			func();
		});
		const sub_child2 = child2.onDestroy(() => {
			sub_parent.unsubscribe();
			sub_child1.unsubscribe();
			func();
		});
		const sub_parent = parent.onDestroy(() => {
			sub_child1.unsubscribe();
			sub_child2.unsubscribe();
		});
	}
}
